import React from "react";

const TimeAgo = ({ dateStr }) => {
  if (!dateStr) {
    return null;
  }

  let currentDate = new Date();
  let inputDate = new Date(dateStr);

  const MILLISECONDS_IN_SECOND = 1000;
  const MILLISECONDS_IN_MINUTE = 60 * MILLISECONDS_IN_SECOND;
  const MILLISECONDS_IN_HOUR = 60 * MILLISECONDS_IN_MINUTE;
  const MILLISECONDS_IN_DAY = 24 * MILLISECONDS_IN_HOUR;
  const MILLISECONDS_IN_MONTH = 30 * MILLISECONDS_IN_DAY;
  const MILLISECONDS_IN_YEAR = 12 * MILLISECONDS_IN_MONTH;

  let diffInMilliSeconds = Math.abs(
    currentDate.getTime() - inputDate.getTime(),
  );

  let diffInMinutes = Math.round(diffInMilliSeconds / MILLISECONDS_IN_MINUTE);
  let diffInHours = Math.round(diffInMilliSeconds / MILLISECONDS_IN_HOUR);
  let diffInDays = Math.round(diffInMilliSeconds / MILLISECONDS_IN_DAY);
  let diffInMonths = Math.round(diffInMilliSeconds / MILLISECONDS_IN_MONTH);
  let diffInYears = Math.round(diffInMilliSeconds / MILLISECONDS_IN_YEAR);

  if (diffInYears > 0) {
    return <span>{inputDate.toDateString()}</span>;
  }

  let value = 0;
  let unit = "day";

  if (diffInMonths > 0) {
    value = diffInMonths;
    unit = "month";
  } else if (diffInDays > 0) {
    value = diffInDays;
    unit = "day";
  } else if (diffInHours > 0) {
    value = diffInHours;
    unit = "hour";
  } else if (diffInMinutes > 0) {
    value = diffInMinutes;
    unit = "minute";
  } else {
    return <span>Just now</span>;
  }

  if (value > 1) {
    unit += "s";
  }

  return (
    <span>
      {value} {unit} ago
    </span>
  );
};

export default TimeAgo;
